import { render, staticRenderFns } from "./HomeContainerIntro.vue?vue&type=template&id=485ed499"
import script from "./HomeContainerIntro.vue?vue&type=script&lang=js"
export * from "./HomeContainerIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports